export default "__VITE_ASSET__7b8_Pv7i__"